
// This is mapped to the DB

export const APIClient = {
    MYDAY: 1
};

Object.freeze(APIClient);